(function ($) {
  $(document).ready(function () {
    // Ensure theme object is defined
    if (typeof theme === "undefined") {
      window.theme = {
        moneyFormat: "£{{amount}}", // Default money format
        finance: {
          rate: 10, // Default finance rate
          numberOfPayments: 12, // Default number of payments
        },
        // Add other necessary default properties
      };
    }

    // ---------------------------------------     Custom Upsell Feature     --------------------------------------- //

    const btnAddToCart = document.querySelector("[data-product-submit]");
    const btnQuickAddToCart = document.querySelector(
      "[data-product-quick-add]",
    );
    const variantSelectors = document.querySelector("[data-variant-selectors]");
    const upsell = document.querySelector("[data-custom-product-upsell]");
    const productDataSelector = document.querySelector("[data-product-json]");

    if (upsell != null) {
      const btnClose = upsell.querySelector("[data-upsell-close-btn]");
      const chooseBtns = upsell.querySelectorAll("[data-upsell-choose-btn]");
      const chooseItems = upsell.querySelectorAll("[data-upsell-choose-item]");
      const backBtns = upsell.querySelectorAll("[data-upsell-back-btn]");
      const mainOptionsText = upsell.querySelector(
        "[data-main-variant-options-text]",
      );
      const mainVariantImage = upsell.querySelector(
        "[data-main-variant-image]",
      );
      const totalPrice = upsell.querySelector("[data-total-price]");
      const mainFinance = upsell.querySelector("[data-upsell-finance-monthly]");
      const cardSubmitBtns = upsell.querySelectorAll(
        "[data-card-variant-submit]",
      );
      const cardVariantSelects = upsell.querySelectorAll(
        "[data-card-variant-select]",
      );
      const removeBtns = upsell.querySelectorAll("[data-cart-remove]");
      // const standardServiceBtn = document.querySelector('.config-item-btn[data-card-title="Standard"]');

      removeBtns.forEach((btn) => {
        btn.addEventListener("click", async () => {
          const id = btn.dataset.cartLineId;
          // const p = btn.dataset.cartLineProperty;

          const cartData = await getCartData();
          const items = cartData.items;

          for (let i = 0; i < items.length; i++) {
            const item = items[i];
            const itemId = item.variant_id;

            if (id == itemId) {
              const price = item.price;
              const title = item.product_title;
              const key = item.key;

              fetch(window.Shopify.routes.root + "cart/change.js", {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                },
                body: JSON.stringify({
                  id: key,
                  quantity: 0,
                }),
              })
                .then((response) => {
                  console.log(response);
                })
                .catch((error) => {
                  console.error("Error:", error);
                });

              const parent = btn.closest(".config-item-text");
              const addToCartBtn = parent.querySelector(
                "[data-card-variant-submit]",
              );
              addToCartBtn.classList.remove("added");
              btn.classList.add("disabled");

              const itemParent = btn.closest(".config-item");
              itemParent.classList.remove("item-added");

              const currentTotalPrice = totalPrice.dataset.totalPriceNoCurrency;
              const newTotalPrice = Number(currentTotalPrice) - Number(price);

              totalPrice.innerHTML = formatMoney(
                newTotalPrice,
                theme.moneyFormat,
              );
              totalPrice.dataset.totalPriceNoCurrency = newTotalPrice;

              const result = finance(
                newTotalPrice,
                theme.finance.rate,
                theme.finance.numberOfPayments,
                0,
              ); // 1
              mainFinance.innerHTML = formatMoney(result, theme.moneyFormat);
              mainFinance.dataset.financeMonthlyNoCurrency = result;

              const liElement = upsell.querySelector(
                `.chosen-text li[data-item-title="${title}"]`,
              );
              liElement.remove();

              // const cartNum = Number(cartCount.textContent);
              // cartCount.textContent = cartNum - 1;

              const configParent = btn.closest(".custom-upsell__config");
              const collectionHandle = configParent.dataset.configId;
              const collectionItem = upsell.querySelector(
                `.config-item[data-collection-handle="${collectionHandle}"]`,
              );
              const categoryImage = collectionItem.querySelector(
                ".config-item-image img",
              );
              const liArray =
                collectionItem.querySelectorAll(".chosen-text li");

              if (!liArray.length) {
                collectionItem.classList.remove("chosen");

                categoryImage.src = categoryImage.dataset.src;
              } else if (liArray.length == 1) {
                const configItems =
                  configParent.querySelectorAll(".config-item");

                configItems.forEach((item) => {
                  const submitBtn = item.querySelector(
                    "[data-card-variant-submit]",
                  );

                  if (submitBtn.classList.contains("added")) {
                    categoryImage.src = item.querySelector("img").src;
                  }
                });
              }
            }
          }
        });
      });

      cardVariantSelects.forEach((select) => {
        select.addEventListener("change", (event) => {
          const itemParent = select.closest(".config-item");
          const btnSubmit = itemParent.querySelector(
            "[data-card-variant-submit]",
          );
          const comparePriceSelector = itemParent.querySelector(
            "[data-card-variant-compare-price-text]",
          );
          const priceSelector = itemParent.querySelector(
            "[data-card-variant-price-text]",
          );

          const price = Number(
            select.options[select.selectedIndex].dataset.cardVariantPrice,
          );
          const comparePrice = Number(
            select.options[select.selectedIndex].dataset
              .cardVariantComparePrice,
          );

          if (comparePrice > price) {
            comparePriceSelector.classList.remove("compare-price-hide");
            priceSelector.classList.remove("text-tropical");
          } else {
            comparePriceSelector.classList.add("compare-price-hide");
            priceSelector.classList.add("text-tropical");
          }

          comparePriceSelector.innerHTML = formatMoney(
            comparePrice,
            theme.moneyFormat,
          ).replace(".00", "");
          priceSelector.innerHTML = formatMoney(
            price,
            theme.moneyFormat,
          ).replace(".00", "");

          btnSubmit.dataset.cardVariantId = event.target.value;

          const newImage =
            select.options[select.selectedIndex].dataset.cardImage;
          const imageSelector = itemParent.querySelector(
            ".config-item-image img",
          );

          if (newImage) {
            imageSelector.src = newImage;
            imageSelector.srcset = newImage;
          }
        });
      });

      cardSubmitBtns.forEach((btn) => {
        btn.addEventListener("click", async () => {
          if (!btn.classList.contains("added")) {
            const itemParent = btn.closest(".config-item");
            if (
              !btn.classList.contains("added") &&
              !itemParent.classList.contains("config-item-acc-dmg-cover")
            ) {
              const existingServiceItem = document.querySelector(
                ".config-item-service.item-added [data-cart-remove]",
              );

              if (existingServiceItem) {
                await new Promise((resolve) => {
                  existingServiceItem.click();

                  setTimeout(resolve, 500);
                });
              }
            }

            const formData = {
              items: [
                {
                  id: btn.dataset.cardVariantId,
                  quantity: 1,
                },
              ],
            };

            fetch(window.Shopify.routes.root + "cart/add.js", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify(formData),
            })
              .then((response) => {
                btn.classList.add("added");

                const parent = btn.closest(".custom-upsell__config");
                const textParent = btn.closest(".config-item-text");
                const imageParent = btn.closest(".config-item");
                imageParent.classList.add("item-added");
                const btnBack = parent.querySelector("[data-upsell-back-btn]");
                const remove = textParent.querySelector("[data-cart-remove]");
                const collectionHandle = parent.dataset.configId;
                const collectionItem = upsell.querySelector(
                  `.config-item[data-collection-handle="${collectionHandle}"]`,
                );
                const textWrapper =
                  collectionItem.querySelector(".chosen-text");
                const imageWrapper =
                  collectionItem.querySelector(".config-item-image");
                const categoryImage = imageWrapper.querySelector("img");

                remove.classList.remove("disabled");
                remove.dataset.cartLineId = btn.dataset.cardVariantId;
                remove.dataset.cartLineProperty = productData.title;

                let li = document.createElement("li");
                li.dataset.itemTitle = btn.dataset.cardTitle;
                li.appendChild(document.createTextNode(btn.dataset.cardTitle));
                textWrapper.appendChild(li);

                const item = btn.closest(".config-item");
                const select = item.querySelector("[data-card-variant-select]");

                const noCurrencyPrice =
                  select.options[select.selectedIndex].dataset.cardVariantPrice;
                const currentTotalPrice =
                  totalPrice.dataset.totalPriceNoCurrency;
                const newTotalPrice =
                  Number(noCurrencyPrice) + Number(currentTotalPrice);

                totalPrice.innerHTML = formatMoney(
                  newTotalPrice,
                  theme.moneyFormat,
                );
                totalPrice.dataset.totalPriceNoCurrency = newTotalPrice;

                const result = finance(
                  newTotalPrice,
                  theme.finance.rate,
                  theme.finance.numberOfPayments,
                  0,
                ); // 1
                mainFinance.innerHTML = formatMoney(result, theme.moneyFormat);
                mainFinance.dataset.financeMonthlyNoCurrency = result;

                // const cartNum = Number(cartCount.textContent);
                // cartCount.textContent = cartNum + 1;

                // if (cartCount.classList.contains('hide')) {
                //   cartCount.classList.remove('hide');
                // }

                if (!collectionItem.classList.contains("chosen")) {
                  collectionItem.classList.add("chosen");

                  const imgUrl = imageParent.querySelector("img").src;
                  categoryImage.src = imgUrl;
                } else {
                  if (categoryImage.src != categoryImage.dataset.src) {
                    categoryImage.src = categoryImage.dataset.src;
                  }
                }

                if (collectionItem.dataset.auto == "true") {
                  setTimeout(() => {
                    btnBack.click();
                  }, 1000);

                  if (window.innerWidth < 768) {
                    setTimeout(() => {
                      scrollFunc(collectionItem);
                    }, 2000);
                  }
                }
              })
              .catch((error) => {
                console.error("Error:", error);
              });
          }
        });
      });

      if (btnClose) {
        btnClose.addEventListener("click", () => {
          upsell.classList.remove("is-visible");

          // const request = new XMLHttpRequest();
          // request.addEventListener('load', handleResponse);
          // request.open('GET', '/?sections=header', true);
          // request.send();
        });
      }

      if (upsell) {
        upsell.addEventListener("click", (e) => {
          const popupContent = upsell.querySelector(".custom-upsell__window");

          if (!popupContent.contains(e.target)) {
            btnClose.click();
          }
        });
      }

      chooseBtns.forEach((btn) => {
        btn.addEventListener("click", () => {
          // if (btn.closest('.config-item').classList.contains('services') && !btn.closest('.config-item').classList.contains('chosen')) {
          //   standardServiceBtn.click();
          // }
          configFunc(btn);
        });
      });

      backBtns.forEach((btn) => {
        btn.addEventListener("click", () => {
          configFunc(btn);

          if (window.innerWidth < 768) {
            const parent = btn.closest(".custom-upsell__config");
            const collectionHandle = parent.dataset.configId;
            const collectionItem = upsell.querySelector(
              `.custom-upsell__config.category-list .config-item[data-collection-handle="${collectionHandle}"]`,
            );

            if (collectionItem.classList.contains("chosen")) {
              setTimeout(() => {
                scrollFunc(collectionItem);
              }, 1000);
            }
          }
        });
      });

      if (btnAddToCart) {
        btnAddToCart.addEventListener("click", (e) => {
          if (
            e.target.classList.contains("product-form__buttons-call") ||
            e.target.classList.contains("product-form__buttons-or")
          )
            return;
          e.preventDefault();

          resetPopup();

          const variant = getVariantFromSerializedArray(productData, options());
          mainOptionsText.innerHTML = variant.title.replaceAll(" / ", ", ");

          // Check if variant.featured_image exists, if not use the first product image
          let variantImage = variant.featured_image
            ? variant.featured_image.src
            : null;

          // If variantImage is null, fallback to the first product image
          if (!variantImage && productData.images.length > 0) {
            variantImage = productData.images[0];
          }

          if (variantImage) {
            mainVariantImage.src = variantImage;
          }

          totalPrice.innerHTML = formatMoney(variant.price, theme.moneyFormat);
          totalPrice.dataset.totalPriceNoCurrency = variant.price;

          const result = finance(
            variant.price,
            theme.finance.rate,
            theme.finance.numberOfPayments,
            0,
          ); // 1
          mainFinance.innerHTML = formatMoney(result, theme.moneyFormat);
          mainFinance.dataset.financeMonthlyNoCurrency = result;

          const popupWindow = upsell.querySelector(".custom-upsell__window");
          const pwHeight = popupWindow.clientHeight;
          popupWindow.style.height = pwHeight + "px";

          // upsell.classList.add('is-visible');

          const formData = {
            items: [
              {
                id: variant.id,
                quantity: 1,
              },
            ],
          };

          fetch(window.Shopify.routes.root + "cart/add.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(formData),
          })
            .then((response) => {
              const mainOptions = productData.options;
              const optionIndex = mainOptions.indexOf("Width");

              if (mainOptions.length > 0 && optionIndex > -1) {
                const text = variant.options[optionIndex];
                const textArr = text.split("(");
                let compareText = "";

                if (textArr.length == 1) {
                  compareText = textArr[0];
                } else {
                  compareText = textArr[1].replace(")", "");
                }

                changeSelectedVariant(compareText);
              }

              // const cartNum = Number(cartCount.textContent);
              // cartCount.textContent = cartNum + 1;

              // if (cartCount.classList.contains('hide')) {
              //   cartCount.classList.remove('hide');
              // }

              upsell.classList.add("is-visible");
            })
            .catch((error) => {
              console.error("Error:", error);
            });
        });
      }

      if (btnQuickAddToCart) {
        btnQuickAddToCart.addEventListener("click", (e) => {
          btnAddToCart.click();
        });
      }

      const windowSize = () => {
        if (window.innerWidth < 768) {
          chooseItems.forEach((item) => {
            item.addEventListener("click", () => {
              // if (item.classList.contains('services') && !item.classList.contains('chosen')) {
              //   standardServiceBtn.click();
              // }
              configFunc(item);
            });
          });
        }
      };

      window.addEventListener("resize", windowSize);
      windowSize();

      document.addEventListener(
        "keyup",
        (event) => {
          const keyCode = event.code;

          if (keyCode === "Escape" && upsell.classList.contains("is-visible")) {
            btnClose.click();
          }
        },
        false,
      );
    }
    // const cartCount = document.querySelector("#flyout-cart-link .cart");

    const configFunc = (that) => {
      const parent = that.closest(".custom-upsell__config");
      parent.classList.remove("is-visible");
      parent.classList.remove("is-active");

      const handle = that.dataset.collectionHandle;

      if (handle == undefined) {
        var config = upsell.querySelector(
          ".custom-upsell__config.category-list",
        );
      } else {
        var config = upsell.querySelector(`[data-config-id="${handle}"]`);
      }

      config.classList.add("is-visible");
      config.classList.add("is-active");
    };

    function handleResponse() {
      const header = document.querySelector("header");
      const flyCart = document.getElementById("flyout-cart");
      const respJson = JSON.parse(this.responseText);

      const temp = document.createElement("DIV");
      temp.innerHTML = respJson.header;

      const oldFlyCart = header.querySelector("#flyout-cart");
      const oldFlyCartSummary = oldFlyCart.querySelector(
        "#flyout-cart .flyout-cart-summary",
      );
      const oldFlyCartBasket = oldFlyCart.querySelector(
        "#flyout-cart .flyout-cart-basket",
      );

      const newFlyCartSummary = temp.querySelector(
        "#flyout-cart .flyout-cart-summary",
      );
      const newFlyCartBasket = temp.querySelector(
        "#flyout-cart .flyout-cart-basket",
      );

      oldFlyCart.replaceChild(newFlyCartSummary, oldFlyCartSummary);
      oldFlyCart.replaceChild(newFlyCartBasket, oldFlyCartBasket);

      if (window.innerWidth >= 1280) {
        flyCart.style.display = "block";
      }
    }

    // Getting product and variant objects
    const productData =
      productDataSelector && JSON.parse(productDataSelector.textContent);

    const _createOptionArrayFromOptionCollection = (product, collection) => {
      var optionArray = [];

      collection.forEach(function (option) {
        for (var i = 0; i < product.options.length; i++) {
          if (product.options[i].toLowerCase() === option.name.toLowerCase()) {
            optionArray[i] = option.value;
            break;
          }
        }
      });

      return optionArray;
    };

    const getVariantFromOptionArray = (product, options) => {
      var split_character = "&";

      var split_options = product.options.filter(function (option) {
        return option.includes(split_character);
      });

      var new_options = options;
      // var new_options = [...options];

      if (split_options.length) {
        var all_split_option_elements = [
          ...document.querySelectorAll("[data-product-split-option]"),
        ];

        split_options.forEach(function (split_option, split_option_index) {
          const optionPosition = product.options.indexOf(split_option) + 1;

          var split_option_elements = all_split_option_elements.filter((x) =>
            x.id.toString().startsWith(`productOption-${optionPosition}`),
          ); //split_option.position

          var split_option_values = split_option_elements.reduce(function (
            prev,
            curr,
            index,
            array,
          ) {
            var nodeType = curr.type
              ? curr.type.toLowerCase()
              : curr.nodeName.toLowerCase();

            var value;
            if (nodeType === "select-one") {
              value = curr.options[curr.selectedIndex].value;
            } else if (
              nodeType === "checkbox" ||
              nodeType === "radio" ||
              nodeType === "option"
            ) {
              if (curr.checked || curr.selected) {
                value = curr.value;
              }
            } else {
              value = curr.value;
            }

            if (value) {
              if (prev === "") {
                return `${value}`;
              }
              return `${prev} ${split_character} ${value}`;
            }
            return prev;
          }, "");

          new_options[optionPosition - 1] = split_option_values;
        });
      }

      var result = product.variants.filter(function (variant) {
        return new_options.every(function (option, index) {
          return variant.options[index] === option;
        });
      });

      return result[0] || null;
    };

    const getVariantFromSerializedArray = (product, collection) => {
      const optionArr = _createOptionArrayFromOptionCollection(
        product,
        collection,
      );
      return getVariantFromOptionArray(product, optionArr);
    };

    const serializeOptionValues = (inputs, transform) => {
      return inputs.reduce(function (options, input) {
        if (
          input.checked ||
          (input.type !== "radio" && input.type !== "checkbox")
        ) {
          options.push(transform({ name: input.name, value: input.value }));
        }

        return options;
      }, []);
    };

    const initInputs = (selector) => {
      var elements = Array.prototype.slice.call(
        variantSelectors.querySelectorAll(selector),
      );
      return elements;
    };

    const options = () => {
      return serializeOptionValues(
        initInputs('[name^="options"]'),
        function (item) {
          var regex = /(?:^(options\[))(.*?)(?:\])/;
          item.name = regex.exec(item.name)[2];
          return item;
        },
      );
    };

    const formatMoney = (t, e) => {
      "string" == typeof t && (t = t.replace(".", ""));
      var n = "",
        r = /\{\{\s*(\w+)\s*\}\}/,
        i = e || "${{amount}}";

      function o(t) {
        var e =
            arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 2,
          n =
            arguments.length > 2 && void 0 !== arguments[2]
              ? arguments[2]
              : ",",
          r =
            arguments.length > 3 && void 0 !== arguments[3]
              ? arguments[3]
              : ".";
        if (isNaN(t) || null == t) return 0;
        var i = (t = (t / 100).toFixed(e)).split("."),
          o = i[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + n),
          a = i[1] ? r + i[1] : "";
        return o + a;
      }
      switch (i.match(r)[1]) {
        case "amount":
          n = o(t, 2);
          break;
        case "amount_no_decimals":
          n = o(t, 0);
          break;
        case "amount_with_comma_separator":
          n = o(t, 2, ".", ",");
          break;
        case "amount_no_decimals_with_comma_separator":
          n = o(t, 0, ".", ",");
      }
      return i.replace(r, n);
    };

    const finance = (t, e, n, r, i) => {
      var o,
        a,
        s,
        u = e / 12 / 100;
      return (
        r
          ? 1 === r && ((o = c(n)), (a = Math.pow(1 + u, n) - 1))
          : ((o = c(12 * n)), (a = Math.pow(1 + u, 12 * n) - 1)),
        (s = t * (o / a)),
        Math.round(100 * s) / 100
      );

      function c(t) {
        return (i && (t -= 1), u * Math.pow(1 + u, t));
      }
    };

    const scrollFunc = (item) => {
      const index = Number(item.dataset.index);
      const w = item.offsetWidth;
      const c = item.closest(".config-item-wrapper");
      const p = c.scrollLeft;
      let next = null;
      let nextNext = null;
      let prev = null;
      let prevPrev = null;

      switch (index) {
        case 1:
          next = item.nextSibling.nextElementSibling;
          nextNext = next.nextSibling.nextElementSibling;

          if (!next.classList.contains("chosen")) {
            const n = w - p;
            // c.scrollLeft += n;
            c.scrollTo({
              left: c.scrollLeft + n,
              behavior: "smooth",
            });
          } else if (!nextNext.classList.contains("chosen")) {
            const n = 2 * w - p;
            c.scrollTo({
              left: c.scrollLeft + n,
              behavior: "smooth",
            });
          }
          break;
        case 2:
          next = item.nextSibling.nextElementSibling;
          prev = item.previousSibling.previousElementSibling;

          if (!next.classList.contains("chosen")) {
            const n = 2 * w - p;
            c.scrollTo({
              left: c.scrollLeft + n,
              behavior: "smooth",
            });
          } else if (!prev.classList.contains("chosen")) {
            c.scrollTo({
              left: 0,
              behavior: "smooth",
            });
          }
          break;
        case 3:
          prev = item.previousSibling.previousElementSibling;
          prevPrev = prev.previousSibling.previousElementSibling;

          if (!prevPrev.classList.contains("chosen")) {
            c.scrollTo({
              left: 0,
              behavior: "smooth",
            });
          } else if (!prev.classList.contains("chosen")) {
            const n = w - (2 * w - p);
            c.scrollTo({
              left: c.scrollLeft - n,
              behavior: "smooth",
            });
          }
          break;
        default:
          break;
      }
    };

    async function getCartData() {
      const result = await fetch("/cart.json");

      if (result.status === 200) {
        return result.json();
      }

      throw new Error(
        `Failed to get request, Shopify returned ${result.status} ${result.statusText}`,
      );
    }

    const changeSelectedVariant = (text) => {
      const items = upsell.querySelectorAll(
        ".config-item.contain-width-option",
      );

      items.forEach((item) => {
        const select = item.querySelector("[data-card-variant-select]");
        const options = select.options;
        const firstText = options[0].textContent;

        if (!firstText.includes(text)) {
          for (let i = 0; i < options.length; i++) {
            const tempText = options[i].textContent;

            if (tempText.includes(text)) {
              select.value = options[i].value;
              select.dispatchEvent(new Event("change"));
              break;
            }
          }
        }
      });
    };

    const resetPopup = () => {
      const categoryConfig = upsell.querySelector(
        ".custom-upsell__config.category-list",
      );
      const categoryConfigItem = categoryConfig.querySelectorAll(
        "[data-upsell-choose-item]",
      );

      categoryConfigItem.forEach((item) => {
        item.classList.remove("chosen");
        item.querySelector(".config-item-chosen .chosen-text").innerHTML = "";
      });

      const productListConfig = upsell.querySelectorAll(
        ".custom-upsell__config.product-list",
      );

      productListConfig.forEach((productConfig) => {
        const productItems = productConfig.querySelectorAll(".config-item");

        productItems.forEach((item) => {
          const submitBtn = item.querySelector("[data-card-variant-submit]");
          submitBtn.classList.remove("added");

          const removeBtn = item.querySelector("[data-cart-remove]");
          removeBtn.classList.add("disabled");
        });
      });
    };

    // ---------------------------------------     Custom Delivery Checker Feature     --------------------------------------- //

    const deliveryCheckerWrapper = document.querySelector(".delivery-checker");
    const deliveryCheckBtn = document.querySelector(
      "[data-postcode-check-btn]",
    );
    const deliveryCheckBtnTexts =
      deliveryCheckBtn && deliveryCheckBtn.querySelector(".btn-text-group");
    const deliveryCheckBtnIcon =
      deliveryCheckBtn &&
      deliveryCheckBtn.querySelector(".btn-infinite-rotate");
    const deliveryMessage = document.querySelector("[data-delivery-message]");
    const postcodeInput = document.querySelector("[data-postcode-input]");

    const optionInput = document.querySelectorAll('input[name^="options"]');
    // const stockIndicator = document.querySelector('[data-stock-indicator-light]');

    const deliveryMsg3Selector = document.querySelector(
      "[data-delivery-message-3-json]",
    );
    const deliveryMsg3 =
      deliveryMsg3Selector && JSON.parse(deliveryMsg3Selector.textContent);

    const deliveryMsgErrorSelector = document.querySelector(
      "[data-delivery-message-error-json]",
    );
    const deliveryMsgError =
      deliveryMsgErrorSelector &&
      JSON.parse(deliveryMsgErrorSelector.textContent);

    const deliveryMsg1_2Selectors = document.querySelectorAll(
      "[data-delivery-message-1-2-json]",
    );
    const deliveryMsg1_2 = [];

    deliveryMsg1_2Selectors.forEach((selector) => {
      const msg = JSON.parse(selector.textContent);
      deliveryMsg1_2.push(msg);
    });

    //check if US or UK
    let isUS = false;
    if (deliveryCheckerWrapper?.classList.contains("delivery-checker--us")) {
      isUS = true;
    }

    // Stock indicator light module when changing variant
    optionInput.forEach((option) => {
      option.addEventListener("change", () => {
        const variant = getVariantFromSerializedArray(productData, options());
        const stockIndicator = document.querySelector(
          "[data-stock-indicator-light]",
        );

        // override by Delivery - MTO variant metafields
        const variantMetaDataSelector = document.querySelector(
          "[data-delivery_mto-json]",
        );
        const variantMetaData = JSON.parse(variantMetaDataSelector.textContent);

        if (variantMetaData[variant.id].delivery_mto == true) {
          stockIndicator.classList.add("out-of-stock");
        } else {
          stockIndicator.classList.remove("out-of-stock");
        }

        if (postcodeInput.value != "") {
          deliveryCheckBtn.click();
        }
      });
    });

    // Show delivery message
    const showDeliveryMsg = (deliveryMsg) => {
      const headingArea = deliveryMessage.querySelector(".heading span");
      headingArea.innerHTML = deliveryMsg.heading;

      const subheadingArea = deliveryMessage.querySelector(".sub-heading span");
      subheadingArea.innerHTML = deliveryMsg.subheading;

      const footerArea = deliveryMessage.querySelector(".message-footer");
      if (deliveryMsg.footer == "") footerArea.textContent = "";
      else footerArea.textContent = deliveryMsg.footer;

      const bodyArea = deliveryMessage.querySelector(".message-body");
      if (deliveryMsg.body == "") bodyArea.innerHTML = "";
      else bodyArea.innerHTML = deliveryMsg.body;

      const refArea = deliveryMessage.querySelector(".message-ref");

      if (deliveryMsg.ref == "") refArea.innerHTML = "";
      else refArea.innerHTML = deliveryMsg.ref;

      setTimeout(() => {
        deliveryMessage.classList.add("is-visible");
        deliveryCheckBtnTexts.removeAttribute("hidden");
        deliveryCheckBtnIcon.setAttribute("hidden", "true");
      }, 500);
    };

    // Tiered check for area 1 & 2
    const tieredMsgCheck = () => {
      deliveryMsg1_2.sort((a, b) => Number(b.level) - Number(a.level));
      const variant = getVariantFromSerializedArray(productData, options());
      const variantMetaDataSelector = document.querySelector(
        "[data-delivery_mto-json]",
      );
      const variantMetaData = JSON.parse(variantMetaDataSelector.textContent);

      if (variantMetaData[variant.id].delivery_mto == true) {
        for (let i = 0; i < deliveryMsg1_2.length; i++) {
          const msg = deliveryMsg1_2[i];
          if (msg.key != "empty") {
            deliveryMessage.classList.add("out-of-stock");
            showDeliveryMsg(msg);
            break;
          }
        }
      } else {
        for (let i = 0; i < deliveryMsg1_2.length; i++) {
          const msg = deliveryMsg1_2[i];
          if (msg.key == "empty") {
            deliveryMessage.classList.remove("out-of-stock");
            showDeliveryMsg(msg);
            break;
          }
        }
      }
    };

    const revertDeliveryBtnColor = () => {
      deliveryCheckBtn.style.color = "#102437";
    };

    // Delivery check Function
    const deliveryCheckFunc = (postcode) => {
      const extract = postcode.replace(/\s/g, "");

      if (extract.length > 7 || (isUS == true && extract.length != 5)) {
        deliveryMessage.classList.remove("out-of-stock");
        showDeliveryMsg(deliveryMsgError);
        revertDeliveryBtnColor();
        return false;
      }

      let flag = "";

      for (let i = 0; i < window.postcodeArea1.length; i++) {
        const element = window.postcodeArea1[i];

        if (postcode.toUpperCase().indexOf(element) == 0 && element.length) {
          flag = "first";
          break;
        }
      }

      if (flag == "") {
        for (let i = 0; i < window.postcodeArea2.length; i++) {
          const element = window.postcodeArea2[i];

          if (postcode.toUpperCase().indexOf(element) == 0 && element.length) {
            flag = "second";
            break;
          }
        }
      }

      if (flag == "") {
        for (let i = 0; i < window.postcodeArea3.length; i++) {
          const element = window.postcodeArea3[i];

          if (postcode.toUpperCase().indexOf(element) == 0 && element.length) {
            flag = "third";
            break;
          }
        }
      }

      if (flag == "first" || flag == "second") {
        tieredMsgCheck();
        revertDeliveryBtnColor();
        return false;
      } else if (flag == "third") {
        deliveryMessage.classList.remove("out-of-stock");
        showDeliveryMsg(deliveryMsg3);
        revertDeliveryBtnColor();
        return false;
      } else {
        deliveryMessage.classList.remove("out-of-stock");
        showDeliveryMsg(deliveryMsgError);
        revertDeliveryBtnColor();
        return false;
      }
    };

    if (postcodeInput) {
      postcodeInput.addEventListener("change", (event) => {
        if (
          postcodeInput.value == "" &&
          deliveryMessage.classList.contains("is-visible")
        ) {
          deliveryMessage.classList.remove("is-visible");
        }
      });

      postcodeInput.onkeypress = function (e) {
        var key = e.charCode || e.keyCode || 0;
        if (key == 13) {
          e.preventDefault();
          deliveryCheckBtn && deliveryCheckBtn.click();
        }
      };
    }

    // Delivery check events
    if (deliveryCheckBtn) {
      deliveryCheckBtn.addEventListener("click", (e) => {
        deliveryMessage && deliveryMessage.classList.remove("is-visible");
        deliveryCheckBtnIcon && deliveryCheckBtnIcon.removeAttribute("hidden");
        deliveryCheckBtnTexts &&
          deliveryCheckBtnTexts.setAttribute("hidden", "true");
        deliveryCheckBtn.style.color = "#fff";

        postcodeInput && deliveryCheckFunc(postcodeInput.value);
        return false;
      });
    }

    // ---------------------------------------     Klarna payment     --------------------------------------- //
    const addFinanceCalculations = () => {
      const selectors = {
        productFinanceContainer: "[data-finance-container]",
        productPrice: "[data-product-price]",
        financeMonthly: "[data-finance-monthly]",
      };

      let settings = {
        debug: false,
        minimumValue: 0,
        financeType: 1,
      };

      settings.minimumValue = theme.finance.minimumValue * 100;
      let productFinanceContainers = document.querySelectorAll(
        selectors.productFinanceContainer,
      );

      if (!productFinanceContainers) return;

      productFinanceContainers.forEach((el_productFinanceContainer) => {
        if (!el_productFinanceContainer) return;

        let el_productPrice =
            el_productFinanceContainer.querySelector(selectors.productPrice) ||
            el_productFinanceContainer,
          el_financeMonthly = el_productFinanceContainer.querySelector(
            selectors.financeMonthly,
          );

        if (!el_productPrice || !el_financeMonthly) return;

        let price = parseInt(el_productPrice.dataset.productPrice);

        let financeDepositAmount = theme.finance.depositPercent
          ? price / theme.finance.depositPercent
          : 0;
        var financeAmount = price - financeDepositAmount;

        if (settings.debug)
          console.log("Finance calculated", {
            productPrice: price,
            financeAmount: financeAmount,
          });

        if (price >= settings.minimumValue) {
          const result = finance(
            financeAmount,
            theme.finance.rate,
            theme.finance.numberOfPayments,
            settings.financeType,
          );
          el_financeMonthly.textContent = formatMoney(
            result,
            theme.moneyFormat,
          );
          el_productFinanceContainer.removeAttribute("hidden");

          if (el_productFinanceContainer.parentElement) {
            // Remove class from parent div of `el_productFinanceContainer` in case it was added previously when price was lower than minimum value
            el_productFinanceContainer.parentElement.classList.remove(
              "finance-not-available",
            );
          }
        } else {
          el_productFinanceContainer.hidden = true;

          if (el_productFinanceContainer.parentElement) {
            // Add class to parent div of `el_productFinanceContainer` to control styling when finance option is not available due to price being lower than minimum value
            el_productFinanceContainer.parentElement.classList.add(
              "finance-not-available",
            );
          }
        }
      });
    };

    addFinanceCalculations();

    document.querySelectorAll("[data-product-price]").forEach((el) => {
      el.addEventListener("priceChange", () => {
        addFinanceCalculations();
      });
    });
  });
})(jQuery);
